import React from "react";
import { Routes, Route, useLocation } from "react-router-dom";
import {
  Navbar,
  Footer,
  Error404,
  Home,
  Aboutus,
  Contactus,
  Donations,
} from "./routes/Routes";


import PrivateRoute from "./hooks/PrivateRoute";
import Login from "./routes/auth/login";

import AdminNavbar from "./routes/auth/Navbar/AdminNavbar.js";
import Dashboard from "./routes/auth/dashboard";
import AdminContactus from "./routes/auth/Admin/AdminContactus.jsx";
import PaymentHistory from "./routes/auth/PaymentHistory";
import Renewal from "./routes/auth/Renewal";
import WebsitesCheck from "./routes/auth/Admin/WebsitesCheck";
import GoogelAnalytics from "./routes/auth/Admin/GoogelAnalytics.jsx";

import OurMission from "./routes/Services/OurMission.jsx";
import OurKids from "./routes/Services/OurKids.jsx";
import OurStories from "./routes/Services/OurStories.jsx";
import EducationCME from "./routes/Services/EducationCME.jsx";

const routes = [
  { path: "/", element: <Home /> },
  { path: "/*", element: <Error404 /> },

  { path: "/auth/login", element: <Login /> },
  {
    path: "/auth/dashboard",
    element: (
      <PrivateRoute>
        <Dashboard />
      </PrivateRoute>
    ),
  },

  {
    path: "/auth/contactus",
    element: (
      <PrivateRoute>
        <AdminContactus />
      </PrivateRoute>
    ),
  },
  
  {
    path: "/auth/dashboard/paymenthistory",
    element: (
      <PrivateRoute>
        <PaymentHistory />
      </PrivateRoute>
    ),
  },
  {
    path: "/auth/google-analytics",
    element: (
      <PrivateRoute>
        <GoogelAnalytics />
      </PrivateRoute>
    ),
  },

  {
    path: "/auth/dashboard/websitecheck",
    element: (
      <PrivateRoute>
        <WebsitesCheck />
      </PrivateRoute>
    ),
  },
  {
    path: "/auth/dashboard/renewal",
    element: (
      <PrivateRoute>
        <Renewal />
      </PrivateRoute>
    ),
  },

  { path: "/aboutus", element: <Aboutus /> },
  { path: "/donate-now", element: <Donations /> },
  { path: "/contactus", element: <Contactus /> },

  { path: "/our-mission", element: <OurMission /> },
  { path: "/our-kids", element: <OurKids /> },
  { path: "/our-stories", element: <OurStories /> },
  { path: "/education-cme", element: <EducationCME /> },
];

export function App() {
  const location = useLocation();

  // Any route that starts with "/auth" (e.g., /auth/dashboard, /auth/contactus)
  const isAuthRoute =
    location.pathname.startsWith("/auth") &&
    location.pathname !== "/auth/login";

  window.scrollTo(0, 0);

  return (
    <>
      {isAuthRoute && <AdminNavbar />}
      {!isAuthRoute && <Navbar />}

      <div className="flex flex-1">
        <div
          className={`flex-1 min-w-0 transition-all duration-300 ${isAuthRoute ? "mt-14 md:ml-64" : "mt-0"
            }`}
        >
          <Routes location={location} key={location.pathname}>
            {routes.map((route, index) => (
              <Route key={index} path={route.path} element={route.element} />
            ))}
          </Routes>

          {!isAuthRoute && <Footer />}
        </div>
      </div>
    </>
  );
}

export default App;
